import React from 'react';
import SMOSpaceEditBaseFragment from './SMOSpaceEditBaseFragment';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMConst from 'lib/SMConst';

class SMOSpaceEditTextFragment extends SMOSpaceEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      space: this.props.space,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      space : nextProps.space,
    });
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>予約承認時
          <span className="dashboard-title__supplement ml15">
            予約の承認時に必ずゲストに伝える内容を入力します。
          </span>
        </h2>
        <SMFormTextAreaWithError name="confirmation_description"
          value={this.state.space.confirmation_description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'confirmation_description', this.props.errors)}
          placeholderText="予約リクエストありがとうございます。日程等問題ありませんので承認させていただきます。どうぞよろしくお願いいたします。"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>予約確定時
          <span className="dashboard-title__supplement ml15">
            予約の確定（支払完了）時に必ずゲストに伝える内容を入力します。
          </span>
        </h2>
        <SMFormTextAreaWithError name="conversion_description"
          value={this.state.space.conversion_description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'conversion_description', this.props.errors)}
          placeholderText="鍵の受け渡しは当日受付にて行います。プロジェクター、Wi-Fi、ホワイトボードなど一式無料でご利用できますのでご安心ください。"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>予約否認時
          <span className="dashboard-title__supplement ml15">
            予約の否認時に必ずゲストに伝える内容を入力します。
          </span>
        </h2>
        <SMFormTextAreaWithError name="reject_description"
          value={this.state.space.reject_description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'reject_description', this.props.errors)}
          placeholderText="大変申し訳ありません。本日程ですが、ビルの緊急メンテナンス日となってしまいました。またご予約いただけますことを心よりお待ちしております。"
          delegate={this} />

        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>

        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.SpaceText} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}
SMOSpaceEditTextFragment.defaultProps = {
  errors: [],
};
export default SMOSpaceEditTextFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditTextFragment.jsx